<template>
  <div>
    <div
      @click="showSelection"
      class="select-label has-background-light"
      style="width: 100%"
    >
      <span style="display: flex">
        <span v-if="!Selected.length">Select {{ name }} &nbsp; </span>

        <span> {{ getSelection.join(", ") }}</span>
      </span>

      <input type="text" v-model="form" style="display: none" />

      <div
        class="select-box"
        v-if="select"
        v-click-outside="() => chooseSelection()"
      >
        <span class="select-box-title">
          <span style="color: white">{{ name }}</span>
        </span>

        <div class="search" style="margin: 10px">
          <input
            v-model="searchText"
            type="text"
            class="input"
            placeholder="Type name"
          />
        </div>

        <div class="select-list">
          <div
            class="select-item"
            v-for="(i, index) in getFilterData"
            :key="index"
          >
            <label class="checkbox is-multiline" style="width: 100%">
              <input type="checkbox" :value="i._id" v-model="Selected" />

              <span style="margin-left: 10px"> {{ i.name }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
export default {
  props: ["selection", "data", "updateText", "name", "value"],
  data: () => ({
    Selected: [],
    select: false,
    searchText: "",
    form: [],
  }),
  directives: {
    clickOutside: vClickOutside.directive,
  },

  // created() {
  //   this.form = this.value
  // },
  computed: {
    getSelection() {
      const filter = this.data.filter((i) => {
        return this.form.includes(i._id);
      });
      const mapper = filter.map((i) => i.name);
      return mapper;
    },

    getFilterData() {
      return this.data.filter((i) => {
        return i.name.toLowerCase().match(this.searchText.toLowerCase());
      });
    },
  },
  created() {
    this.form = this.value;
    this.chooseSelection();
  },
  methods: {
    showSelection() {
      this.select = true;
    },
    chooseSelection() {
      this.select = false;
      this.form = this.Selected;
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit("input", val);
      },
      immediate: true,
      deep: true,
    },
    updateText: {
      handler(val) {
        this.Selected = val;
        this.chooseSelection();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  border: 2px solid var(--alert-color);
  color: var(--alert-color);
}

.select-label {
  position: absolute;
  width: 46%;
  cursor: pointer;
  margin: 0;
  padding: 9px;
  font-size: 16px;
  transition: all ease-in-out 0.2s;
  font-weight: 500;

  .placeholder {
    color: var(--primary-color);
  }

  .select-box {
    z-index: 999;
    position: relative;
    padding-top: 12px;
    width: 100%;
    border-radius: 5px;
    background-color: var(--primary-color);
    box-shadow: 0 0px 20px 5px rgba(var(--grey-color), 0.5);
    top: -5px;
    position: absolute;

    .close-btn {
      margin-left: auto;
      cursor: pointer;
    }

    .select-box-title {
      padding: 0 20px;
      display: flex;
      justify-content: space-between;

      &:hover {
        color: inherit;
      }
    }

    .select {
      padding: 10px 20px 20px;

      input {
        background-color: var(--light-grey-color);
        box-shadow: none;
        box-shadow: unset;
        border: none;
        box-shadow: 0px 0px 0px 2px rgba(var(--primary-color), 1);
      }
    }

    .select-list {
      margin-top: 10px;
      background-color: #fff;

      display: block;
      height: 200px;
      overflow-y: scroll;

      .select-item {
        font-size: 14px;
        white-space: pre-line;
        margin: 0;

        transition: all ease-in-out 0.1s;
        cursor: pointer;

        label {
          padding: 12px;
        }

        &:not(:last-child) {
          border-bottom: 1px solid var(--border-color);
        }

        &:hover {
          background-color: #dbdbdb;
        }

        p {
          margin: 0;
        }
      }
    }
  }

  // search-box
}
</style>
